(function () {
  const state = {
    base: null,
    paste: [],
    latte: null,
    zucchero: null,
    subtotal: 0,
    discountRate: 0.15,
    total: 0
  };

  const money = (value) => {
    return new Intl.NumberFormat('it-IT', {
      style: 'currency',
      currency: 'EUR'
    }).format(value || 0);
  };

  function isComplete() {
    return !!state.base && state.paste.length >= 1 && !!state.latte && !!state.zucchero;
  }

  function calculateTotals() {
    const pasteTotal = state.paste.reduce((acc, item) => acc + (item.price || 0), 0);

    state.subtotal =
      (state.base?.price || 0) +
      pasteTotal +
      (state.latte?.price || 0) +
      (state.zucchero?.price || 0);

    const discountValue = isComplete() ? state.subtotal * state.discountRate : 0;
    state.total = state.subtotal - discountValue;
  }

  function updateSummary() {
    const baseEls = document.querySelectorAll('[data-kit-choice="base"]');
    const pasteEls = document.querySelectorAll('[data-kit-choice="paste"]');
    const latteEls = document.querySelectorAll('[data-kit-choice="latte"]');
    const zuccheroEls = document.querySelectorAll('[data-kit-choice="zucchero"]');

    baseEls.forEach((el) => {
      el.textContent = state.base?.title || '—';
    });

    pasteEls.forEach((el) => {
      el.textContent = state.paste.length
        ? state.paste.map((item) => item.title).join(', ')
        : '—';
    });

    latteEls.forEach((el) => {
      el.textContent = state.latte?.title || '—';
    });

    zuccheroEls.forEach((el) => {
      el.textContent = state.zucchero?.title || '—';
    });

    const discountValue = isComplete() ? state.subtotal * state.discountRate : 0;

    document.querySelectorAll('[data-kit-subtotal]').forEach((el) => {
      el.textContent = money(state.subtotal);
    });

    document.querySelectorAll('[data-kit-discount]').forEach((el) => {
      el.textContent = `- ${money(discountValue)}`;
    });

    document.querySelectorAll('[data-kit-total]').forEach((el) => {
      el.textContent = money(state.total);
    });

    const progressEl = document.querySelector('[data-kit-progress]');
    if (progressEl) {
      let completed = 0;
      if (state.base) completed += 1;
      if (state.paste.length >= 1) completed += 1;
      if (state.latte) completed += 1;
      if (state.zucchero) completed += 1;
      progressEl.textContent = `${completed}/4 completate`;
    }

    const mobileTotal = document.querySelector('[data-kit-mobile-total]');
    if (mobileTotal) {
      mobileTotal.textContent = money(state.total);
    }

    document.querySelectorAll('[data-kit-status]').forEach((el) => {
      el.textContent = isComplete()
        ? 'Il tuo kit è pronto'
        : 'Completa le 4 scelte per attivare il kit';
    });

    document.querySelectorAll('[data-kit-add-to-cart]').forEach((btn) => {
      btn.disabled = !isComplete();
      btn.setAttribute('aria-disabled', String(!isComplete()));
    });
  }

  function render() {
    calculateTotals();
    updateSummary();
  }

  function bindDrawer() {
    const drawer = document.querySelector('[data-kit-drawer]');
    const openBtn = document.querySelector('[data-kit-open-drawer]');
    const closeBtns = document.querySelectorAll('[data-kit-close-drawer]');

    if (openBtn && drawer) {
      openBtn.addEventListener('click', () => {
        drawer.hidden = false;
        document.body.classList.add('kit-drawer-open');
      });
    }

    closeBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        drawer.hidden = true;
        document.body.classList.remove('kit-drawer-open');
      });
    });
  }

  function bindAddToCart() {
    document.querySelectorAll('[data-kit-add-to-cart]').forEach((btn) => {
      btn.addEventListener('click', () => {
        if (!isComplete()) return;

        const nativeButton =
          document.querySelector('[name="add"]') ||
          document.querySelector('.shopify-payment-button__button') ||
          document.querySelector('button[type="submit"]');

        if (nativeButton) nativeButton.click();
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    bindDrawer();
    bindAddToCart();
    render();
  });

  window.kitGelatoState = state;
  window.kitGelatoRender = render;
})();